/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { makeStyles } from '@material-ui/core/styles';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
const useStyles = makeStyles((theme) => ({
  code_marTop: {
    marginTop: '8px',
  },
}));
export default function ClaimIdentification(props) {
  const { claimDetails } = props;
  const classes = useStyles();
  return (
    <div>
      <div className="row">
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Patient</legend>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="id"
                  label="ID:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.patientVO?.id||''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="name"
                  label="Name:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.patientVO?.name||''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="age"
                  label="Age:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.patientVO?.age||''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="gender"
                  label="Gender:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.patientVO?.gender||''}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Provider</legend>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="nabp"
                  label="NABP:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.providerVO?.nabpNum||''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="provider_name"
                  label="Name:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={claimDetails?.identificationVO?.providerVO?.name||''}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  data-testid="WAC_percent"
                  id="taxonomy"
                  label="Taxonomy:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={
                    claimDetails?.identificationVO?.providerVO
                      ?.providerTaxonomyCd||''
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset" style={{ height: '100%' }}>
            <legend className="same-font-family">Plan</legend>
            <div className="form-wrapper" style={{ paddingTop: '0px' }}>
              <div className="mui-custom-form input-md field-sm">
                <TextField
                  data-testid="WAC_percent"
                  id="client"
                  label="Client:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={
                    claimDetails?.identificationVO?.planVO?.clientId
                      ? claimDetails?.identificationVO?.planVO?.clientId
                      : ''
                  }
                  className={`${classes.code_marTop}`}
                />
              </div>
              <div className="mui-custom-form input-md field-lg">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="clientName">
                      {claimDetails?.identificationVO?.planVO?.clientName}
                    </Tooltip>
                  }
                >
                  <TextField
                    data-testid="WAC_percent"
                    id="clientName"
                    fullWidth
                    placeholder=""
                    disabled
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 11 }}
                    value={
                      claimDetails?.identificationVO?.planVO?.clientName
                        ? claimDetails?.identificationVO?.planVO?.clientName
                        : ''
                    }
                  />
                </OverlayTrigger>
              </div>
              <div className="mui-custom-form input-md field-sm">
                <TextField
                  data-testid="WAC_percent"
                  id="group"
                  label="Group:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={
                    claimDetails?.identificationVO?.planVO?.groupId
                      ? claimDetails?.identificationVO?.planVO?.groupId
                      : ''
                  }
                  className={`${classes.code_marTop}`}
                />
              </div>
              <div className="mui-custom-form input-md field-lg">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="groupName">
                      {claimDetails?.identificationVO?.planVO?.groupName}
                    </Tooltip>
                  }
                >
                  <TextField
                    data-testid="WAC_percent"
                    id="groupName"
                    fullWidth
                    placeholder=""
                    disabled
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 11 }}
                    value={
                      claimDetails?.identificationVO?.planVO?.groupName
                        ? claimDetails?.identificationVO?.planVO?.groupName
                        : ''
                    }
                  />
                </OverlayTrigger>
              </div>
              <div className="mui-custom-form input-md field-sm">
                <TextField
                  data-testid="WAC_percent"
                  id="plan"
                  label="Plan:"
                  fullWidth
                  placeholder=""
                  disabled
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 11 }}
                  value={
                    claimDetails?.identificationVO?.planVO?.planId
                      ? claimDetails?.identificationVO?.planVO?.planId
                      : ''
                  }
                  className={`${classes.code_marTop}`}
                />
              </div>
              <div className="mui-custom-form input-md field-lg">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="planName">
                      {claimDetails?.identificationVO?.planVO?.planName}
                    </Tooltip>
                  }
                >
                  <TextField
                    data-testid="WAC_percent"
                    id="planName"
                    fullWidth
                    placeholder=""
                    disabled
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 11 }}
                    value={
                      claimDetails?.identificationVO?.planVO?.planName
                        ? claimDetails?.identificationVO?.planVO?.planName
                        : ''
                    }
                  />
                </OverlayTrigger>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
